import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

export function ForbiddenPage() {
  const { t } = useTranslation('common');

  return (
    <div className="h-full bg-background flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        {/* 403 Number */}
        <div className="mb-6">
          <span className="text-[120px] font-bold text-destructive leading-none">
            403
          </span>
        </div>

        {/* Icon */}
        <div className="mb-6 flex justify-center">
          <div className="w-20 h-20 rounded-full bg-destructive/10 flex items-center justify-center">
            <svg
              className="w-10 h-10 text-destructive"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="1.5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
              />
            </svg>
          </div>
        </div>

        {/* Text Content */}
        <h1 className="text-2xl font-semibold text-foreground mb-2">
          {t('forbidden.title')}
        </h1>
        <p className="text-muted-foreground mb-8">
          {t('forbidden.description')}
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            variant="outline"
            onClick={() => window.history.back()}
          >
            {t('forbidden.goBack')}
          </Button>
          <Button asChild>
            <a href="/app/dashboard">
              {t('forbidden.backToDashboard')}
            </a>
          </Button>
        </div>
      </div>
    </div>
  );
}
